<div class="container py-20" *ngIf="width == 'CONSTRAINED'">
    <div class="row two-column-row d-flex flex-column-reverse flex-sm-column-reverse flex-md-row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
            <img loading="lazy" class="icon" src="{{ serverUrl }}/{{ icon }}" />
            <h2 class="title mt-4">{{ title }}</h2>
            <h5 class="subtitle">{{ subtitle }}</h5>
            <p class="description text-dark font-size-14">{{ description }}</p>
            
            <a routerLink="{{ url }}">
                <button class="btn btn-primary btn-lg font-weight-bold font-size-16">{{ button }}</button>
            </a>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 d-flex justify-content-md-end mb-10">
            <img loading="lazy" src="{{ serverUrl }}/{{ thumbnail }}" class="img-fluid thumbnail" />
        </div>
    </div>
</div>

<div class="container-fluid py-20" *ngIf="width == 'FULL'">
    <div class="row two-column-row d-flex flex-column-reverse flex-sm-column-reverse flex-md-row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
            <img loading="lazy" class="icon" src="{{ serverUrl }}/{{ icon }}" />
            <h2 class="title mt-4">{{ title }}</h2>
            <h5 class="subtitle">{{ subtitle }}</h5>
            <p class="description text-dark font-size-14">{{ description }}</p>
            
            <a routerLink="{{ url }}">
                <button class="btn btn-primary btn-lg font-weight-bold font-size-16">{{ button }}</button>
            </a>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7 d-flex justify-content-md-end mb-10">
            <img loading="lazy" src="{{ serverUrl }}/{{ thumbnail }}" class="img-fluid thumbnail" />
        </div>
    </div>
</div>